export default class ProductUtil {

    static parseProductUnit = (item:any, product_variants:any, product_units_lockup:any)=>{
        const unitItemRoot = product_units_lockup['root']
        let product_variants_units:any = product_variants?.reduce((prevVariant: any, itemVariant:any)=>{
            const unitItem = product_units_lockup[itemVariant?.unit_value]
            if(itemVariant?.parent_id?.id === item?.id){
                prevVariant = [...prevVariant,{
                    price: itemVariant?.price,
                    price_transfer: itemVariant?.price_transfer,
                    price_wholesale: itemVariant?.price_wholesale,
                    name: unitItem?.name,
                    value: unitItem?.id,
                    label: unitItem?.name,
                    quantity_conversion: itemVariant?.unit_value
                }]
            }
            return prevVariant
        },[])
        if(!product_variants_units) product_variants_units = []
        console.log("parseProductUnit", item?.name, product_variants_units, product_variants)
        return [
            {
                price: item?.price,
                price_transfer: item?.price_transfer,
                price_wholesale: item?.price_wholesale,
                name: unitItemRoot?.name,
                quantity_conversion: unitItemRoot?.quantity_conversion,
                value: 0,
                label: unitItemRoot?.name,
            },
            ...product_variants_units
        ]
    }
    
    static parseProductBatch = (batch:any)=>{
        return batch?.reduce((prev:any, item:any)=>{
            prev = [
                ...prev,{
                    ...item,
                    label: item?.name,
                    value: item?.id,
                }
            ]
            return prev
        },[])
    }
    
    static parseProduct = (dataProduct:any)=>{
        const data:any = dataProduct?.reduce((prev:any, item:any)=>{
            //stock
            const product_stock_lockup:any = {}
            item?.product_stock?.map((itemUnit:any)=>{
                if(!product_stock_lockup[itemUnit?.variant_id?.id || 'root']) product_stock_lockup[itemUnit?.variant_id?.id || 'root'] = {}
                if(!product_stock_lockup[itemUnit?.variant_id?.id || 'root'][itemUnit?.branch_id?.id]) product_stock_lockup[itemUnit?.variant_id?.id || 'root'][itemUnit?.branch_id?.id] = {}
                if(!product_stock_lockup[itemUnit?.variant_id?.id || 'root'][itemUnit?.branch_id?.id][itemUnit?.batch_id?.id || 'root']) product_stock_lockup[itemUnit?.variant_id?.id || 'root'][itemUnit?.branch_id?.id][itemUnit?.batch_id?.id || 'root'] = {}
                product_stock_lockup[itemUnit?.variant_id?.id || 'root'][itemUnit?.branch_id?.id][itemUnit?.batch_id?.id || 'root'] = Number(itemUnit?.quantity)
            })
            //unit
            const product_units_lockup:any = {}
            product_units_lockup['root'] = {
                name: item?.minimum_unit,
                quantity_conversion: 1
            }
            item?.product_units?.map((itemUnit:any)=>{
                product_units_lockup[itemUnit?.quantity_conversion] = itemUnit
            })
            const product_variants = item?.product_variants
            const product_variants_units:any = ProductUtil.parseProductUnit(item, product_variants, product_units_lockup)
            const itemRoot = {
                name: item?.name,
                sku: item?.sku,
                stock_max: item?.stock_max,
                stock_min: item?.stock_min,
                type: item?.type,
                status: item?.status,
                height: item?.height,
                weight: item?.weight,
                width: item?.width,
                longs: item?.longs,
                vat: item?.vat,
                price: item?.price,
                price_import: item?.price_import,
                price_transfer: item?.price_transfer,
                price_cancel: item?.price_cancel,
                price_wholesale: item?.price_wholesale,
                price_cost: item?.price_cost,
                product_id: item?.id,
                variant_id: null,
                value: `${item?.id}`,
                label: item?.name,
                avatar: item?.product_images && item?.product_images[0] && item?.product_images[0]?.url,
                units: product_variants_units,
                batchs: ProductUtil.parseProductBatch(item?.product_batchs || []),
                stock_quantity: product_stock_lockup,
                ingredient: item?.ingredient,
                used_unit: item?.used_unit,
                usage: item?.usage,
                product_type: item?.product_type
            }
            if(item.product_variants && item.product_variants?.length > 0 && item.product_variants?.length !== product_variants_units?.length){
                const itemVariants = item.product_variants?.reduce((prevVariant: any, itemVariant:any)=>{
                    if(!itemVariant?.parent_id){
                        const product_variants_units:any = ProductUtil.parseProductUnit(itemVariant, product_variants, product_units_lockup)
                        prevVariant = [...prevVariant,{
                            ...itemRoot,
                            name: itemVariant?.name,
                            sku: itemVariant?.sku,
                            vat: itemVariant?.vat,
                            price: itemVariant?.price,
                            price_import: itemVariant?.price_import,
                            price_transfer: itemVariant?.price_transfer,
                            price_cancel: itemVariant?.price_cancel,
                            price_wholesale: itemVariant?.price_wholesale,
                            price_cost: itemVariant?.price_cost,
                            product_id: item?.id,
                            variant_id: itemVariant?.id,
                            value: `${item?.id}-${itemVariant?.id}`,
                            label: itemVariant?.name,
                            units: product_variants_units,
                            batchs: ProductUtil.parseProductBatch(itemVariant?.product_batchs || []),
                        }]
                    }
                    return prevVariant
                },[])
                prev = [...prev, ...itemVariants]
            }else{
                prev = [...prev,itemRoot]
            }
            return prev
        },[])
        return data
    }
}

class ProductImportUtil {

    //Import - Request
    static parseProductUnit = (item:any, product_variants:any, product_units_lockup:any)=>{
        const unitItemRoot = product_units_lockup['root']
        let product_variants_units:any = product_variants?.reduce((prevVariant: any, itemVariant:any)=>{
            const unitItem = product_units_lockup[itemVariant?.unit_value]
            if(itemVariant?.parent_id?.id === item?.id){
                prevVariant = [...prevVariant,{
                    price: itemVariant?.price,
                    price_import: itemVariant?.price_import,
                    price_wholesale: itemVariant?.price_wholesale,
                    name: unitItem?.name,
                    value: unitItem?.id,
                    label: unitItem?.name,
                    quantity_conversion: itemVariant?.unit_value
                }]
            }
            return prevVariant
        },[])
        if(!product_variants_units) product_variants_units = []
        return [
            {
                price: item?.price,
                price_import: item?.price_import,
                price_wholesale: item?.price_wholesale,
                name: unitItemRoot?.name,
                quantity_conversion: unitItemRoot?.quantity_conversion,
                value: 0,
                label: unitItemRoot?.name,
            },
            ...product_variants_units
        ]
    }
    
    static parseProductBatch = (batch:any)=>{
        return batch?.reduce((prev:any, item:any)=>{
            prev = [
                ...prev,{
                    ...item,
                    label: item?.name,
                    value: item?.id,
                }
            ]
            return prev
        },[])
    }
    
    static parseProduct = (dataProduct:any)=>{
        const data:any = dataProduct?.reduce((prev:any, item:any)=>{
            const product_units_lockup:any = {}
            product_units_lockup['root'] = {
                name: item?.minimum_unit,
                quantity_conversion: 1
            }
            item?.product_units?.map((itemUnit:any)=>{
                product_units_lockup[itemUnit?.quantity_conversion] = itemUnit
            })
            const product_variants = item?.product_variants
            const product_variants_units:any = ProductUtil.parseProductUnit(item, product_variants, product_units_lockup)
            const itemRoot = {
                name: item?.name,
                sku: item?.sku,
                stock_max: item?.stock_max,
                stock_min: item?.stock_min,
                type: item?.type,
                status: item?.status,
                height: item?.height,
                weight: item?.weight,
                width: item?.width,
                longs: item?.longs,
                vat: item?.vat,
                price: item?.price,
                price_import: item?.price_import,
                price_wholesale: item?.price_wholesale,
                product_id: item?.id,
                variant_id: null,
                value: `${item?.id}`,
                label: item?.name,
                units: product_variants_units,
                batchs: ProductUtil.parseProductBatch(item?.product_batchs || [])
            }
            if(item.product_variants && item.product_variants?.length > 0 && item.product_variants?.length !== product_variants_units?.length){
                const itemVariants = item.product_variants?.reduce((prevVariant: any, itemVariant:any)=>{
                    if(!itemVariant?.parent_id){
                        const product_variants_units:any = ProductUtil.parseProductUnit(itemVariant, product_variants, product_units_lockup)
                        prevVariant = [...prevVariant,{
                            ...itemRoot,
                            name: itemVariant?.name,
                            sku: itemVariant?.sku,
                            vat: itemVariant?.vat,
                            price: item?.price,
                            price_import: itemVariant?.price_import,
                            price_wholesale: itemVariant?.price_wholesale,
                            product_id: item?.id,
                            variant_id: itemVariant?.id,
                            value: `${item?.id}-${itemVariant?.id}`,
                            label: itemVariant?.name,
                            units: product_variants_units,
                            batchs: ProductUtil.parseProductBatch(itemVariant?.product_batchs || [])
                        }]
                    }
                    return prevVariant
                },[])
                prev = [...prev, ...itemVariants]
            }else{
                prev = [...prev,itemRoot]
            }
            return prev
        },[])
        return data
    }
}

class ProductReturnUtil {
    static parseProductUnit = (item:any, product_variants:any, product_units_lockup:any)=>{
        const unitItemRoot = product_units_lockup['root']
        let product_variants_units:any = product_variants?.reduce((prevVariant: any, itemVariant:any)=>{
            const unitItem = product_units_lockup[itemVariant?.unit_value]
            if(itemVariant?.parent_id?.id === item?.id){
                prevVariant = [...prevVariant,{
                    price: itemVariant?.price,
                    price_import: itemVariant?.price_import,
                    price_wholesale: itemVariant?.price_wholesale,
                    name: unitItem?.name,
                    value: unitItem?.id,
                    label: unitItem?.name,
                    quantity_conversion: itemVariant?.unit_value
                }]
            }
            return prevVariant
        },[])
        if(!product_variants_units) product_variants_units = []
        return [
            {
                price: item?.price,
                price_import: item?.price_import,
                price_wholesale: item?.price_wholesale,
                name: unitItemRoot?.name,
                quantity_conversion: unitItemRoot?.quantity_conversion,
                value: 0,
                label: unitItemRoot?.name,
            },
            ...product_variants_units
        ]
    }
    
    static parseProductBatch = (batch:any)=>{
        return batch?.reduce((prev:any, item:any)=>{
            prev = [
                ...prev,{
                    ...item,
                    label: item?.name,
                    value: item?.id,
                }
            ]
            return prev
        },[])
    }
    
    static parseProduct = (dataProduct:any)=>{
        const data:any = dataProduct?.reduce((prev:any, item:any)=>{
            const product_units_lockup:any = {}
            product_units_lockup['root'] = {
                name: item?.minimum_unit,
                quantity_conversion: 1
            }
            item?.product_units?.map((itemUnit:any)=>{
                product_units_lockup[itemUnit?.quantity_conversion] = itemUnit
            })
            const product_variants = item?.product_variants
            const product_variants_units:any = ProductReturnUtil.parseProductUnit(item, product_variants, product_units_lockup)
            const itemRoot = {
                name: item?.name,
                sku: item?.sku,
                stock_max: item?.stock_max,
                stock_min: item?.stock_min,
                type: item?.type,
                status: item?.status,
                height: item?.height,
                weight: item?.weight,
                width: item?.width,
                longs: item?.longs,
                vat: item?.vat,
                price: item?.price,
                price_import: item?.price_import,
                price_wholesale: item?.price_wholesale,
                product_id: item?.id,
                variant_id: null,
                value: `${item?.id}`,
                label: item?.name,
                units: product_variants_units,
                batchs: ProductReturnUtil.parseProductBatch(item?.product_batchs || [])
            }
            if(item.product_variants && item.product_variants?.length > 0 && item.product_variants?.length !== product_variants_units?.length){
                const itemVariants = item.product_variants?.reduce((prevVariant: any, itemVariant:any)=>{
                    if(!itemVariant?.parent_id){
                        const product_variants_units:any = ProductReturnUtil.parseProductUnit(itemVariant, product_variants, product_units_lockup)
                        prevVariant = [...prevVariant,{
                            ...itemRoot,
                            name: itemVariant?.name,
                            sku: itemVariant?.sku,
                            vat: itemVariant?.vat,
                            price: item?.price,
                            price_import: itemVariant?.price_import,
                            price_wholesale: itemVariant?.price_wholesale,
                            product_id: item?.id,
                            variant_id: itemVariant?.id,
                            value: `${item?.id}-${itemVariant?.id}`,
                            label: itemVariant?.name,
                            units: product_variants_units,
                            batchs: ProductReturnUtil.parseProductBatch(itemVariant?.product_batchs || [])
                        }]
                    }
                    return prevVariant
                },[])
                prev = [...prev, ...itemVariants]
            }else{
                prev = [...prev,itemRoot]
            }
            return prev
        },[])
        return data
    }
    
}

class ProductCancelUtil {
    static parseProductUnit = (item:any, product_variants:any, product_units_lockup:any)=>{
        const unitItemRoot = product_units_lockup['root']
        let product_variants_units:any = product_variants?.reduce((prevVariant: any, itemVariant:any)=>{
            const unitItem = product_units_lockup[itemVariant?.unit_value]
            if(itemVariant?.parent_id?.id === item?.id){
                prevVariant = [...prevVariant,{
                    price: itemVariant?.price,
                    price_cancel: itemVariant?.price_cancel,
                    price_wholesale: itemVariant?.price_wholesale,
                    name: unitItem?.name,
                    value: unitItem?.id,
                    label: unitItem?.name,
                    quantity_conversion: itemVariant?.unit_value
                }]
            }
            return prevVariant
        },[])
        if(!product_variants_units) product_variants_units = []
        return [
            {
                price: item?.price,
                price_cancel: item?.price_cancel,
                price_wholesale: item?.price_wholesale,
                name: unitItemRoot?.name,
                quantity_conversion: unitItemRoot?.quantity_conversion,
                value: 0,
                label: unitItemRoot?.name,
            },
            ...product_variants_units
        ]
    }
    
    static parseProductBatch = (batch:any)=>{
        return batch?.reduce((prev:any, item:any)=>{
            prev = [
                ...prev,{
                    ...item,
                    label: item?.name,
                    value: item?.id,
                }
            ]
            return prev
        },[])
    }
    
    static parseProduct = (dataProduct:any)=>{
        const data:any = dataProduct?.reduce((prev:any, item:any)=>{
            //stock
            const product_stock_lockup:any = {}
            item?.product_stock?.map((itemUnit:any)=>{
                if(!product_stock_lockup[itemUnit?.variant_id?.id || 'root']) product_stock_lockup[itemUnit?.variant_id?.id || 'root'] = {}
                if(!product_stock_lockup[itemUnit?.variant_id?.id || 'root'][itemUnit?.branch_id?.id]) product_stock_lockup[itemUnit?.variant_id?.id || 'root'][itemUnit?.branch_id?.id] = {}
                if(!product_stock_lockup[itemUnit?.variant_id?.id || 'root'][itemUnit?.branch_id?.id][itemUnit?.batch_id?.id || 'root']) product_stock_lockup[itemUnit?.variant_id?.id || 'root'][itemUnit?.branch_id?.id][itemUnit?.batch_id?.id || 'root'] = {}
                product_stock_lockup[itemUnit?.variant_id?.id || 'root'][itemUnit?.branch_id?.id][itemUnit?.batch_id?.id || 'root'] = Number(itemUnit?.quantity)
            })
            //unit
            const product_units_lockup:any = {}
            product_units_lockup['root'] = {
                name: item?.minimum_unit,
                quantity_conversion: 1
            }
            item?.product_units?.map((itemUnit:any)=>{
                product_units_lockup[itemUnit?.quantity_conversion] = itemUnit
            })
            const product_variants = item?.product_variants
            const product_variants_units:any = ProductCancelUtil.parseProductUnit(item, product_variants, product_units_lockup)
            const itemRoot = {
                name: item?.name,
                sku: item?.sku,
                stock_max: item?.stock_max,
                stock_min: item?.stock_min,
                type: item?.type,
                status: item?.status,
                height: item?.height,
                weight: item?.weight,
                width: item?.width,
                longs: item?.longs,
                vat: item?.vat,
                price: item?.price,
                price_cancel: item?.price_cancel,
                price_wholesale: item?.price_wholesale,
                price_cost: item?.price_cost,
                product_id: item?.id,
                variant_id: null,
                value: `${item?.id}`,
                label: item?.name,
                units: product_variants_units,
                batchs: ProductCancelUtil.parseProductBatch(item?.product_batchs || []),
                stock_quantity: product_stock_lockup
            }
            if(item.product_variants && item.product_variants?.length > 0 && item.product_variants?.length !== product_variants_units?.length){
                const itemVariants = item.product_variants?.reduce((prevVariant: any, itemVariant:any)=>{
                    if(!itemVariant?.parent_id){
                        const product_variants_units:any = ProductCancelUtil.parseProductUnit(itemVariant, product_variants, product_units_lockup)
                        prevVariant = [...prevVariant,{
                            ...itemRoot,
                            name: itemVariant?.name,
                            sku: itemVariant?.sku,
                            vat: itemVariant?.vat,
                            price: item?.price,
                            price_cancel: itemVariant?.price_cancel,
                            price_wholesale: itemVariant?.price_wholesale,
                            price_cost: itemVariant?.price_cost,
                            product_id: item?.id,
                            variant_id: itemVariant?.id,
                            value: `${item?.id}-${itemVariant?.id}`,
                            label: itemVariant?.name,
                            units: product_variants_units,
                            batchs: ProductCancelUtil.parseProductBatch(itemVariant?.product_batchs || []),
                        }]
                    }
                    return prevVariant
                },[])
                prev = [...prev, ...itemVariants]
            }else{
                prev = [...prev,itemRoot]
            }
            return prev
        },[])
        return data
    }
}
